<div class="fx-row justify-content-between align-items-center">
  <div class="fx-column">
    <app-back></app-back>
    @if (organization) {
      <div class="fx-row align-items-center justify-content-start">
        <img [src]="organization.logo" class="org-logo" />
        <div class="fx-column ml-10">
          <div class="fx-row align-items-center justify-content-start">
            <span class="page-title">{{organization.name}}</span>
            <div class="chip main outline mb-8 ml-10 small">{{'ADMIN.SINCE' |
              translate}} {{formatDate(organization.createdAt)}}</div>
          </div>
          <span class="page-subtitle">{{organization.headquartersAddress}}</span>
        </div>
      </div>
    }
  </div>
  <div class="fx-row align-items-center">
  @if (canEnter && organization && !organization.platform) {
    <span class="mr-10" [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="(enterBlockedReason() ?? '') | translate"
      [matTooltipDisabled]="!enterBlockedReason()">
      <button type="button" class="main-button" id="access-enter-organization" (click)="enter()"
        [class.disabled]="!!enterBlockedReason()" [disabled]="!!enterBlockedReason()">
        <div class="fx-row align-items-center justify-content-center">
          <mat-icon class="white mr-5" fontSet="material-icons-outlined">login</mat-icon>
          {{ 'ACCESS.ENTER' | translate }}
        </div>
      </button>
    </span>
  }
  @if (deletionPending) {
    <div class="fx-row align-items-center">
      <span class="text light mr-10">
        {{ 'ORGANIZATION.DELETE_ORG_SCHEDULED_AT' | translate: { date: formatDate(deletionPending.scheduledFor) } }}
      </span>
      <button type="button" class="danger-button" (click)="cancelDeletion()">
        {{ 'ORGANIZATION.CANCEL_DELETE' | translate }}
      </button>
    </div>
  } @else if (deletionStateUnknown) {
    <div class="fx-row align-items-center">
      <span class="text light mr-10">
        {{ 'ORGANIZATION.DELETE_ORG_STATE_UNKNOWN' | translate }}
      </span>
      <button type="button" class="danger-button" (click)="retrievePendingDeletion()">
        {{ 'ACTIONS.RETRY' | translate }}
      </button>
    </div>
  } @else {
    <button type="button" class="danger-button" (click)="handleDelete()">
      {{ 'ACTIONS.DELETE' | translate }}
    </button>
  }
  </div>
</div>
<mat-divider class="mv-20"></mat-divider>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'ORGANIZATION.DASHBOARD' | translate}}
    </ng-template>
    <div class="fx-row fx-wrap align-items-center justify-content-start mt-16">
      <div class='fx-row fx-wrap align-items-stretch justify-content-start fx-flex-100'>
        <div class="pr-8 fx-flex-20 border-box">
          <app-counter-card label="ADMIN.DOCUMENTS" [value]="documentsStats.documents"></app-counter-card>
        </div>
        <div class="pl-8 pr-8 fx-flex-20 border-box">
          <app-counter-card label="ADMIN.PAGES" [value]="documentsStats.pages"></app-counter-card>
        </div>
        <div class="pl-8 pr-8 fx-flex-20 border-box">
          <app-counter-card label="ADMIN.SIZE" [value]="formatSize(documentsStats.size).value"
            [unit]="formatSize(documentsStats.size).unit" [round]="10"></app-counter-card>
        </div>
        <div class="pl-8 pr-8 fx-flex-20 border-box">
          <app-counter-card label="ADMIN.COST" [value]="formatCost(documentsStats.cost)" [unit]="'€'"
            [round]="100"></app-counter-card>
        </div>
        <div class="pl-8 pr-8 fx-flex-20 border-box">
          <app-counter-card label="ADMIN.AVG_COST" [value]="formatCost(documentsStats.cost / documentsStats.documents)"
            [unit]="'€'" [round]="100"></app-counter-card>
        </div>
      </div>
      <div class="mt-16 fx-flex-100">
        <mat-card class="p-0">
          <div class="p-16">
            <span class="text bold">{{'ADMIN.DOCUMENTS_GRAPH' | translate}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="p-16">
            <div class="fx-row  align-items-center justify-content-start">
              <div class="fx-column">
                <span class="label">{{'ADMIN.METRIC' | translate}}</span>
                <app-button-toggle [buttons]="metrics" (change)="onMetricChange($event)"></app-button-toggle>
              </div>
              <div class="fx-column ml-10">
                <span class="label">{{'ADMIN.TEMPORALITY' | translate}}</span>
                <app-button-toggle [buttons]="periods" (change)="onPeriodChange($event)"></app-button-toggle>
              </div>
            </div>
          </div>
          <app-documents-graph [data]="documentsGraph" [period]="period" [metric]="metric"></app-documents-graph>
        </mat-card>
      </div>
      <div class="fx-row fx-flex-100 align-items-stretch justify-content-start mt-16">
        <div class="pr-8 fx-flex-50 border-box fx-column">
          <mat-card class="p-0">
            <div class="p-16">
              <span class="text bold">{{'ADMIN.DOCUMENTS_PER_CLASS' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <app-documents-classes [data]="documentsStats.classes"></app-documents-classes>
          </mat-card>
        </div>
        <div class="pl-8 fx-flex-50 border-box fx-column">
          <mat-card class="p-0">
            <div class="p-16">
              <span class="text bold">{{'ADMIN.DOCUMENTS_PER_TYPE' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <app-documents-types [data]="documentsStats.types"></app-documents-types>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="fx-row  align-items-stretch justify-content-start mt-16">
      <div class="pr-8 fx-flex-30 border-box fx-column">
        <app-counter-card label="ADMIN.USERS" [value]="users.totalDocs"></app-counter-card>
        <mat-card class="p-0 mt-16">
          <div class="p-16">
            <span class="text bold">{{'ADMIN.USERS_PER_ROLE' | translate}}</span>
          </div>
          <mat-divider></mat-divider>
          <app-users-pie [data]="usersStats"></app-users-pie>
        </mat-card>
      </div>
      <div class="pl-8 fx-flex-70 fx-column">
        <mat-card class="p-0 fx-flex" style="overflow-y:auto !important; min-height: 0 !important;">
          <div class="p-16">
            <span class="text bold">{{'ADMIN.USERS' | translate}}</span>
          </div>
          <mat-divider></mat-divider>
          <table mat-table [dataSource]="users.docs" style="z-index: 0;" matSort
            (matSortChange)="onSortUsersChange($event)">
            <ng-container matColumnDef="avatar">
              <th mat-header-cell *matHeaderCellDef>
                <span class="small light bold">
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <div class="fx-row align-items-center justify-content-start">
                  <app-avatar [user]="user" [size]="30"></app-avatar>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                  {{'USER.LASTNAME' | translate}}
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <span class="text">{{user.lastName}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                  {{'USER.FIRSTNAME' | translate}}
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <span class="text">{{user.firstName}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                  {{'USER.EMAIL' | translate}}
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <div class="fx-row align-items-center justify-content-start">
                  <a [href]="'mailto:'+user.email">{{user.email}}</a>
                  <mat-icon class="dark ml-5 clickable" inline fontSet="material-icons-outlined"
                    [cdkMenuTriggerFor]="menu"
                    *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">info</mat-icon>
                  <ng-template #menu>
                    <mat-card class="menu-container p-8 elevation" cdkMenu
                      *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">
                      <span class="small dark">{{'USER.INVITED_BY' | translate}}</span>
                      <div class="fx-row justify-content-start align-items-center">
                        <app-avatar [user]="user.invitedBy" [size]="20"></app-avatar>
                        <span class="small ml-5">{{user.invitedBy.firstName}} {{user.invitedBy.lastName}}</span>
                      </div>
                    </mat-card>
                  </ng-template>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="profile">
              <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                  {{'USER.PROFILE' | translate}}
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <app-user-profile [role]="user.role"></app-user-profile>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                  {{'USER.REGISTRATION' | translate}}
                </span>
              </th>
              <td mat-cell *matCellDef="let user">
                <span class="text light" *ngIf="user.passwordVerified">{{formatDate(user.createdAt)}}</span>
                <div *ngIf="!user.passwordVerified" class="fx-row fx-wrap align-items-center justify-content-start">
                  <mat-icon class="light mr-5" fontSet="material-icons-outlined" inline>email</mat-icon>
                  <span class="small light bold">{{'USER.PENDING_INVITE' | translate}}</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let user">
                <!-- <div class="fx-row align-items-center justify-content-end">
              <button mat-icon-button (click)='edit(user)' [disabled]="!canEdit(user)"
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="editTooltip(user)">
                <mat-icon class="main mr-5" [class.lighter]="!canEdit(user)"
                  fontSet="material-icons-outlined">edit</mat-icon>
              </button>
              <button mat-icon-button [disabled]='!canDelete(user)' (click)='delete(user)'
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'ACTIONS.DELETE' | translate">
                <mat-icon [class]="canDelete(user) ? 'red' : 'lighter'"
                  fontSet="material-icons-outlined">delete</mat-icon>
              </button>
            </div> -->
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>
          <div class="p-16" *ngIf="users.totalDocs === 0">
            <span class="text light">{{'ORGANIZATION.SEARCH_NO_USERS' | translate}}</span>
          </div>
          <div class="fx-flex align-items-center justify-content-end">
            <mat-paginator [length]="users.totalDocs || 0" [pageSize]="users.limit || 0"
              [pageIndex]="users.page ? (users.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
              (page)="handleUsersPage($event)">
            </mat-paginator>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="fx-row fx-wrap align-items-stretch justify-content-start mt-16">
      <div class='fx-row align-items-stretch justify-content-start fx-flex-100 mt-16'>
        <div class='fx-flex-70 pr-8 border-box fx-column'>
          <mat-card class="p-0 h-100">
            <div class="p-16">
              <span class="text bold">{{'ADMIN.TRADEMARKS_GEOGRAPHIES' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <app-trademarks-territories [data]="trademarksStats.geographies"
              [count]="trademarksStats.total"></app-trademarks-territories>
          </mat-card>
        </div>
        <div class='fx-flex-30 pl-8 border-box fx-column'>
          <app-counter-card label="ADMIN.TRADEMARKS" [value]="trademarksStats.total"></app-counter-card>
          <mat-card class="p-0 h-100 mt-16">
            <div class="p-16">
              <span class="text bold">{{'ADMIN.TRADEMARKS_STATUSES' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <app-trademarks-statuses [data]="trademarksStats.statuses"
              [count]="trademarksStats.total"></app-trademarks-statuses>
          </mat-card>
        </div>
      </div>
      <div class='fx-flex-100 mt-16 border-box fx-column'>
        <mat-card class="p-0 h-100">
          <div class="p-16">
            <span class="text bold">{{'ADMIN.TRADEMARKS_CLASSES' | translate}}</span>
          </div>
          <mat-divider></mat-divider>
          <app-trademarks-classes [data]="trademarksStats.classes"
            [count]="trademarksStats.total"></app-trademarks-classes>
        </mat-card>
      </div>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'ORGANIZATION.SUBSCRIPTION' | translate}}
    </ng-template>
    <div class="fx-row fx-wrap align-items-center justify-content-start mv-16">
      <mat-card class="fx-flex-100 p-0">
        <div class="p-16 fx-row align-items-center justify-content-between">
          <span class="text bold">{{'ORGANIZATION.SUBSCRIPTION' | translate}}</span>
          <button class="main-button mt-8" (click)="editSubscription()"
            *ngIf="organization && organization.subscription && organization.subscription.plan" roleBasedElement
            [roles]="['SUPERADMIN']">
            {{'ACTIONS.EDIT_SUBSCRIPTION' | translate}}
          </button>
        </div>
        <mat-divider></mat-divider>
        <div *ngIf="organization && (!organization.subscription || !organization.subscription.plan)"
          class="fx-row fx-wrap p-16">
          <div class="fx-row align-items-center justify-content-start fx-flex-100">
            <mat-icon class="red mr-10">error</mat-icon>
            <span class="text bold">{{'ORGANIZATION.NO_PLAN_TEXT' | translate}}</span>
          </div>
          <button class="main-button mt-8" (click)="addSubscription()" roleBasedElement [roles]="['SUPERADMIN']">
            {{'ACTIONS.ADD_SUBSCRIPTION' | translate}}
          </button>
        </div>
        <div *ngIf="organization && organization.subscription && organization.subscription.plan"
          class="fx-row align-items-start justify-content-start pv-16">
          <div class="fx-flex-33 fx-row fx-wrap align-items-center justify-content-start pl-16 pr-16">
            <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-100">
              <span class="page-subtitle bold main mb-16 fx-flex-100">{{'ORGANIZATION.SUBSCRIPTION_PRICE' | translate}}:
                {{subscriptionPrice()}}
                €</span>
              <span class="text bold mb-8  fx-flex-100">{{'ORGANIZATION.BASE_PLAN' | translate}}</span>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'ORGANIZATION.PLAN' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text bold main">{{organization.subscription.plan.label}}</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'PLAN.TYPE' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{'PLAN.TYPE_'+organization.subscription.plan.type | translate}}</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center">
                <span class="text light">{{'PLAN.ANNUAL_PRICE' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text bold">{{organization.subscription.plan.annualPrice}} €</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.plan.maxVolume">
                <span class="text light">{{'PLAN.MAX_VOLUME' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.plan.maxVolume}} Go</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.plan.maxTrademarks">
                <span class="text light">{{'PLAN.MAX_TRADEMARKS' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.plan.maxTrademarks}}</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.plan.maxCases">
                <span class="text light">{{'PLAN.MAX_CASES' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.plan.maxCases}}</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.plan.maxCrawlerUrl">
                <span class="text light">{{'PLAN.MAX_CRAWLER_URL' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.plan.maxCrawlerUrl}}</span>
              </div>
              <span class="text bold mt-16 mb-8  fx-flex-100">{{'ORGANIZATION.OPTIONS' | translate}}</span>
              <span class="text light fx-flex-100"
                *ngIf="!organization.subscription.additionalVolume && !organization.subscription.additionalTrademarks && !organization.subscription.additionalCases && !organization.subscription.additionalCrawlerUrl">{{'ORGANIZATION.NO_OPTION'
                | translate}}</span>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.additionalVolume">
                <span class="text light">{{'ORGANIZATION.ADDITIONAL_VOLUME' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.additionalVolume}} Go / +{{additionalVolumePrice()}}
                  €</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.additionalTrademarks">
                <span class="text light">{{'ORGANIZATION.ADDITIONAL_TRADEMARKS' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.additionalTrademarks}} /
                  +{{additionalTrademarksPrice()}} €</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.additionalCases">
                <span class="text light">{{'ORGANIZATION.ADDITIONAL_CASES' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.additionalCases}} / +{{additionalCasesPrice()}}
                  €</span>
              </div>
              <div class="fx-flex-100 fx-row justify-content-between align-items-center"
                *ngIf="organization.subscription.additionalCrawlerUrl">
                <span class="text light">{{'ORGANIZATION.ADDITIONAL_CRAWLER_URL' | translate}}</span>
                <mat-divider class="mh-10 fx-flex" inline inset></mat-divider>
                <span class="text dark">{{organization.subscription.additionalCrawlerUrl}}</span>
              </div>
            </div>

          </div>
          <div
            class="fx-flex-33 fx-row fx-wrap align-items-center justify-content-start pl-16 pr-16 border-left border-box">
            <span class="text bold mb-8 fx-flex-100">{{'ORGANIZATION.PRICE_BREAKDOWN' | translate}}</span>
            <div id="pricepiediv" #pricepiediv class="price-pie"></div>
          </div>
          <div
            class="fx-flex-33 fx-row fx-wrap align-items-center justify-content-start pl-16 pr-16 border-left border-box">
            <span class="text bold mb-8 fx-flex-100">{{'ORGANIZATION.QUOTAS_CONSUMPTION' | translate}}</span>
            <div class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center mv-8"
              *ngIf="organization.subscription.plan.maxVolume">
              <span class="text main fx-flex-100 ">{{'PLAN.MAX_VOLUME' | translate}}</span>
              <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                <span class="text dark bold">{{round(volumeStats,1)}}/{{totalVolume()}} Go</span>
                <span class="text dark">{{round((100*volumeStats) / totalVolume())}}%</span>
              </div>
              <app-progress-bar [mode]="'determinate'" [value]="(100*volumeStats) / totalVolume()" [loading]="true"
                class="fx-flex-100"></app-progress-bar>
            </div>
            <div class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center mv-8"
              *ngIf="organization.subscription.plan.maxTrademarks">
              <span class="text main fx-flex-100 ">{{'PLAN.MAX_TRADEMARKS' | translate}}</span>
              <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                <span class="text dark bold">{{trademarksStats.total}}/{{totalTrademarks()}}</span>
                <span class="text dark">{{round(trademarksStats.total*100/totalTrademarks())}}%</span>
              </div>
              <app-progress-bar [mode]="'determinate'" [value]="trademarksStats.total*100/totalTrademarks()"
                [loading]="true" class="fx-flex-100"></app-progress-bar>
            </div>
            <div class="fx-flex-100 fx-row fx-wrap justify-content-start align-items-center mv-8"
              *ngIf="organization.subscription.plan.maxCases">
              <span class="text main fx-flex-100 ">{{'PLAN.MAX_CASES' | translate}}</span>
              <div class="fx-flex-100 fx-row fx-wrap justify-content-between align-items-center">
                <span class="text dark bold">{{caseStats.total}}/{{totalCases()}}</span>
                <span class="text dark">{{round(caseStats.total*100/totalCases())}}%</span>
              </div>
              <app-progress-bar [mode]="'determinate'" [value]="caseStats.total*100/totalCases()" [loading]="true"
                class="fx-flex-100"></app-progress-bar>
            </div>
          </div>
        </div>

      </mat-card>
      <mat-card class="fx-flex-100 p-0 mt-16" roleBasedElement [roles]="['SUPERADMIN']">
        <div class="p-16 fx-row align-items-center justify-content-between">
          <div class="fx-column">
            <span class="text bold">{{'CREATE_ORGANIZATION_DIALOG.CLIENT_TYPE' | translate}}</span>
            <span class="text light">{{'ORGANIZATION.CLIENT_TYPE_HINT' | translate}}</span>
          </div>
        </div>
        @if (organization) {
          <mat-divider></mat-divider>
          <div class="p-16 fx-row fx-wrap align-items-center justify-content-start">
            <app-select [value]="organization.clientType" [options]="clientTypeOptions" [emitOnInit]="false"
              [disabled]="loading" [clearable]="false" (change)="onClientTypeChange($event)"></app-select>
          </div>
        }
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'ORGANIZATION.SETTINGS' | translate}}
    </ng-template>
    <div class="fx-row fx-wrap align-items-center justify-content-start mv-16">
      <mat-card class="fx-flex-100 p-0">
        <div class="p-16 fx-row align-items-center justify-content-between">
          <div class="fx-column">
            <span class="text bold">{{'ORGANIZATION.ANALYZER_CONFIGURATION.TITLE' | translate}}</span>
            <span class="text light"
              *ngIf="isDefaultAnalyzerConfiguration">{{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_CONFIGURATION' |
              translate}}</span>
            <span class="text main bold"
              *ngIf="!isDefaultAnalyzerConfiguration">{{'ORGANIZATION.ANALYZER_CONFIGURATION.OVERRIDEN_CONFIGURATION' |
              translate}}</span>
          </div>
          <button class="main-button mt-8" (click)="editAnalyzerConfiguration()" *ngIf="organization " roleBasedElement
            [roles]="['SUPERADMIN']">
            {{'ORGANIZATION.ANALYZER_CONFIGURATION.EDIT_CONFIGURATION' | translate}}
          </button>
        </div>
        <mat-divider></mat-divider>
        <div *ngIf="organization" class="fx-row fx-wrap p-16">

          <div class="fx-row align-items-start justify-content-start fx-flex-100">
            <div class="fx-row fx-wrap align-items-start justify-content-start fx-flex-50 pr-10">
              <span class="text bold fx-flex-100">
                {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES' | translate}}
              </span>
              <div class="fx-column mt-16 fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.countryGuessedFromLang !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.defaultValues.countryGuessedFromLang*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'"
                    [value]="analyzerConfiguration.defaultValues.countryGuessedFromLang*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_EN' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_COUNTRY_GUESSED_FROM_LANG_EN_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.countryGuessedFromLangEN !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.defaultValues.countryGuessedFromLangEN*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'"
                    [value]="analyzerConfiguration.defaultValues.countryGuessedFromLangEN*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_OTHER_DOCUMENT_CLASS' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.DEFAULT_VALUES_OTHER_DOCUMENT_CLASS_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.defaultValues && analyzerConfiguration.defaultValues.otherDocumentClass !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.defaultValues.otherDocumentClass*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'"
                    [value]="analyzerConfiguration.defaultValues.otherDocumentClass*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
            </div>
            <div
              class="fx-row fx-wrap  align-items-start justify-content-start fx-flex-50 pl-10 border-box border-left">
              <span class="text bold">
                {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS' | translate}}
              </span>
              <div class="fx-column mt-16 fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.logoDetection !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.thresholds.logoDetection*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'" [value]="analyzerConfiguration.thresholds.logoDetection*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_IMAGE' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_LOGO_DETECTION_IMAGE_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.logoDetectionImage !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.thresholds.logoDetectionImage*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'"
                    [value]="analyzerConfiguration.thresholds.logoDetectionImage*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_IMAGE_SIMILARITY' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_IMAGE_SIMILARITY_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.imageSimilarity !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.thresholds.imageSimilarity*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'"
                    [value]="analyzerConfiguration.thresholds.imageSimilarity*100" [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_TEXT_SIMILARITY' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_TEXT_SIMILARITY_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.textSimilarity !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.thresholds.textSimilarity*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'" [value]="analyzerConfiguration.thresholds.textSimilarity*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
              <mat-divider class="mv-16 fx-flex-100"></mat-divider>
              <div class="fx-column fx-flex-100">
                <span class="text dark fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_PS_SIMILARITY' | translate}}
                </span>
                <span class="small light fx-flex-100">
                  {{'ORGANIZATION.ANALYZER_CONFIGURATION.THRESHOLDS_PS_SIMILARITY_HINT' | translate}}
                </span>
                <div class="mt-8"
                  *ngIf="analyzerConfiguration && analyzerConfiguration.thresholds && analyzerConfiguration.thresholds.psSimilarity !== undefined">
                  <span class="text main bold fx-flex-100">
                    {{(analyzerConfiguration.thresholds.psSimilarity*100).toFixed(0)}}%
                  </span>
                  <app-progress-bar [mode]="'determinate'" [value]="analyzerConfiguration.thresholds.psSimilarity*100"
                    [loading]="true"></app-progress-bar>
                </div>
              </div>
            </div>
          </div>
        </div>

      </mat-card>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'ORGANIZATION.TRADEMARKS_MANAGEMENT' | translate}}
    </ng-template>
    <div class="fx-row fx-wrap align-items-center justify-content-start mv-16">
      <mat-card class="p-0 fx-flex-100" style="overflow-y:auto !important; min-height: 0 !important;">
        <div class="p-16">
          <span class="text bold">{{'ENTITIES.SYNCHRONIZATIONS' | translate}}</span>
        </div>
        <mat-divider></mat-divider>
        <table mat-table [dataSource]="trademarkBulkSynchronizations.docs" style="z-index: 0;" matSort>
          <ng-container matColumnDef="sync-createdAt">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
                {{'SYNC.CREATED_AT' | translate}}
              </span>
            <td mat-cell *matCellDef="let sync">
              <span class="text light">{{formatDateHour(sync.createdAt)}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="sync-trademarks">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
                {{'SYNC.TRADEMARKS' | translate}}
              </span>
            </th>
            <td mat-cell *matCellDef="let sync">
              <div class="fx-row fx-wrap align-items-center justify-content-start">
                <span class="text">{{sync.trademarks}} {{('ENTITIES.TRADEMARK_S' |
                  translate).toLowerCase()}}</span>
                <mat-icon class="dark ml-5 clickable" inline fontSet="material-icons-outlined"
                  [cdkMenuTriggerFor]="syncMenu" *ngIf="sync.query">info</mat-icon>
                <ng-template #syncMenu>
                  <mat-card class="menu-container p-8 elevation" cdkMenu>
                    <span class="text bold fx-flex-100   mb-8">{{'SYNC.SELECTION_QUERY' | translate}}</span>
                    <div class="fx-row justify-content-start align-items-start">
                      <div class="pr-10 fx-row fx-wrap" [class.fx-flex-50]="sync.query.q"
                        [class.fx-flex-100]="sync.query.q"
                        *ngIf="sync.query.countryOfDesignation && sync.query.countryOfDesignation.length > 0">
                        <span class="small dark mb-5 fx-flex-100">{{'ENTITIES.COUNTRIES' | translate}}</span>&nbsp;
                        <app-document-countries
                          [territories]="sync.query.countryOfDesignation"></app-document-countries>
                      </div>
                      <div class=" fx-row fx-wrap" *ngIf="sync.query.q"
                        [class.fx-flex-50]="sync.query.countryOfDesignation && sync.query.countryOfDesignation.length > 0"
                        [class.fx-flex-100]="!(sync.query.countryOfDesignation && sync.query.countryOfDesignation.length > 0)"
                        [class.border-left]="!(sync.query.countryOfDesignation && sync.query.countryOfDesignation.length > 0)"
                        [class.pl-10]="!(sync.query.countryOfDesignation && sync.query.countryOfDesignation.length > 0)">
                        <span class="small dark mb-5  fx-flex-100">{{'SYNC.QUERY' | translate}}</span>
                        <span class="small light" style="font-style: italic;">"{{sync.query.q}}"</span>
                      </div>
                    </div>
                  </mat-card>
                </ng-template>
              </div>

            </td>
          </ng-container>
          <ng-container matColumnDef="sync-status">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
                {{'SYNC.STATUS' | translate}}
              </span>
            </th>
            <td mat-cell *matCellDef="let sync">
              <div class="fx-row fx-wrap align-items-center justify-content-start">
                <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-start">
                  <mat-icon class="green mr-5" fontSet="material-icons-outlined" *ngIf="sync.status === 'SUCCESS'"
                    style="transform: scale(0.8);">check_circle</mat-icon>
                  <mat-icon class="light mr-5 spin" fontSet="material-icons-outlined" *ngIf="sync.status === 'PENDING'"
                    style="transform: scale(0.8);">sync</mat-icon>
                  <mat-icon class="red mr-5" fontSet="material-icons-outlined" *ngIf="sync.status === 'ERROR'"
                    style="transform: scale(0.8);">error</mat-icon>
                  <span class="text">{{'SYNC.STATUS_'+sync.status | translate}}</span>
                </div>
                <div class="progress-container fx-row align-items-center justify-content-start fx-flex-100"
                  [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="getSyncProgress(sync) + '%'"
                  *ngIf="getSyncProgress(sync) != undefined">
                  <div class="progress" [style.flex-basis.%]="getSyncProgress(sync)">
                  </div>
                </div>
                <span class="text light" *ngIf="getSyncProgress(sync) == undefined">-</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="sync-report">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
                {{'SYNC.REPORT' | translate}}
              </span>
            </th>
            <td mat-cell *matCellDef="let sync">
              <div class="fx-row fx-wrap align-items-center justify-content-start mb-5">
                <span class="text">Score: <span class="text">{{getSyncScore(sync)}}%</span></span>
              </div>
              <div class="score-container fx-row align-items-center justify-content-start fx-flex-100">
                <div class="score ok" [style.flex-basis.%]="100*sync.report.success/sync.report.done"
                  [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="getSyncTooltip(sync,'success')">
                </div>
                <div class="score error" [style.flex-basis.%]="100*sync.report.error/sync.report.done"
                  [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="getSyncTooltip(sync,'error')">
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="sync-requester">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
                {{'SYNC.REQUESTER' | translate}}
              </span>
            </th>
            <td mat-cell *matCellDef="let sync">
              <div class="fx-row justify-content-start align-items-center" *ngIf="sync.requester && sync.requester.ref">
                <app-avatar [user]="sync.requester" [size]="25"></app-avatar>
                <div class="fx-column align-items-start justify-content-start ml-5">
                  <span class="small">{{sync.requester.firstName}} {{sync.requester.lastName}}</span>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="sync-errors">
            <th mat-header-cell *matHeaderCellDef>
              <span class=" small light bold">
              </span>
            </th>
            <td mat-cell *matCellDef="let sync">
              <span class="text red clickable bold"
                *ngIf="sync.report.error > 0 && sync.errors && sync.errors.length > 0"
                (click)='showSyncErrors(sync)'>{{'SYNC.SEE_ERRORS'
                | translate}}</span>
              <span class="text light"
                *ngIf="sync.report.error == 0 || !sync.errors || sync.errors.length == 0">-</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsTrademarkBulkSynchronizations"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsTrademarkBulkSynchronizations;">
          </tr>
        </table>
        <div class="p-16" *ngIf="trademarkBulkSynchronizations.totalDocs === 0">
          <span class="text light">{{'ORGANIZATION.SEARCH_NO_SYNCS' | translate}}</span>
        </div>
        <div class="fx-flex align-items-center justify-content-end">
          <mat-paginator [length]="trademarkBulkSynchronizations.totalDocs || 0"
            [pageSize]="trademarkBulkSynchronizations.limit || 0"
            [pageIndex]="trademarkBulkSynchronizations.page ? (trademarkBulkSynchronizations.page-1) : 0"
            [pageSizeOptions]="[10, 25, 50, 100]" (page)="handleSyncPage($event)">
          </mat-paginator>
        </div>
      </mat-card>

      <mat-card class="p-0 fx-flex-100 mt-16" style="overflow-y:auto !important; min-height: 0 !important;">
        <div class="p-16 fx-flex-100 fx-row align-items-center justify-content-start">
          <div class="fx-flex fx-column">
            <span class="text  bold">{{'ENTITIES.TRADEMARKS' | translate}}</span>
            <span class="text ">{{'ORGANIZATION.BULK_SYNCHRONIZE_SUBTITLE' | translate}}</span>
          </div>

          <button class="main-button ml-20" (click)="bulkSynchronize()">
            <div class="fx-row align-items-center justify-content-center">
              <mat-icon class="white mr-5" fontSet="material-icons-outlined">sync</mat-icon>
              {{'ORGANIZATION.BULK_SYNCHRONIZE' | translate}}
            </div>
          </button>

          @if (tmSelection && tmSelection.selected.length > 0) {
            <div class="danger-button ml-20" (click)="deleteTrademarks()">
              {{ 'ACTIONS.DELETE' | translate }} {{ tmSelection.selected.length }}
              {{ ((tmSelection.selected.length > 1 ? 'ENTITIES.TRADEMARKS' : 'ENTITIES.TRADEMARK') | translate).toLowerCase() }}
            </div>
          }
        </div>
        <mat-divider></mat-divider>

        <div class="fx-row align-items-center justify-content-between mt-16 mb-16">
          <div class="fx-row align-items-center justify-content-start">

            <app-territory-select [value]="trademarksFilters.countryOfDesignation"
              label="{{'ENTITIES.COUNTRY_OF_DESIGNATION' | translate}}" [multiple]="true" [search]="true" initial="none"
              (change)="onTrademarkCountryOfDesignationChange($event)" [emitOnInit]="false" style="width:210px;"
              class="ml-10"></app-territory-select>

            <app-select [value]="trademarksFilters.synchronization" [options]="synchronizationOptions"
              label="{{'SYNC.STATE' | translate}}" [multiple]="true" [emitOnInit]="false"
              (change)="onTrademarkSynchronizationChange($event)" class="ml-10" style="width:210px;"></app-select>

            <div class="fx-row fw-wrap align-items-baseline justify-content-start ml-10">
              <app-animated-number [value]="trademarks.totalDocs" [class]="'bold main'"></app-animated-number>
              &nbsp;
              <span class="text"><span class="bold main">{{((trademarks.totalDocs > 1 ? 'ENTITIES.TRADEMARKS' :
                  'ENTITIES.TRADEMARK') |
                  translate).toLowerCase()}}</span> {{('UTILS.MATCHING' | translate).toLowerCase()}}</span>
            </div>
          </div>
          <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search"
            [(value)]="trademarksFilters.query" (change)="onQueryChange($event)"></app-input>
        </div>
        <app-trademarks-table [selection]="tmSelection" [select]="true" [dataSource]="trademarksDataSource"
                              [trademarks]="trademarks"
          (sort)="onTrademarkSortChange($event)" (page)="handleTrademarkPage($event)"
          columnsStorageKey="admin-organization-trademarks"></app-trademarks-table>
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>
